import { getWindowLocation } from './getWindowLocation';
export const getHideNewThreadLink = () => {
  return getWindowLocation().paramValue('hideNewThreadLink') === 'true';
};